<lib-card>
	Get the most from the app by using it on your phone / tablet.

	<lib-divider class="push-top push-bottom"></lib-divider>
	<mod-install-button [buttonType]="'primary'"></mod-install-button>
</lib-card>
@if (showAppStoreInfo()) {
<lib-card [title]="storeTitle()" class="push-top-md">
	<div>
		<p>
			Instead of a traditional app, Gymvio is available as a <strong>Progressive Web App (PWA)</strong>. This
			means you can access it right from your browser — no downloads needed!
		</p>

		<h4>Why we chose a PWA:</h4>
		<ul>
			<li><strong>Works everywhere:</strong> Use Gymvio on iOS, Android, or desktop — all with one version.</li>
			<li>
				<strong>Easy access:</strong> Just visit our website and add it to your home screen. No app store
				required.
			</li>
			<li><strong>Always up to date:</strong> Gymvio updates automatically when you're online.</li>
			<li><strong>Fast & smooth:</strong> PWAs load quickly and work well even on slower networks.</li>
			<li><strong>Smaller footprint:</strong> No large downloads, and it saves space on your device.</li>
		</ul>

		<p>
			Going the PWA route helps us focus on building better features, faster — and making Gymvio available to more
			people.
		</p>

		<p>Thanks for being part of the Gymvio community!</p>
	</div>
</lib-card>
}
